export const throwError = () => {
  throw new Error();
};
